import Cookies from 'js-cookie'

const app = {
    state: {
        sidebar: {
            opened: !+Cookies.get('sidebarStatus')
        },
        convertPdfName: '',
        watermarkAttach: false,
        // 사내계약 계약완료 시 리턴되는 리스트
        officeContractInfos: null,
        officeContractMetaStr: null,
    },
    mutations: {
        TOGGLE_SIDEBAR: state => {
            if (state.sidebar.opened) {
                Cookies.set('sidebarStatus', 1)
            } else {
                Cookies.set('sidebarStatus', 0)
            }
            state.sidebar.opened = !state.sidebar.opened
        },
        convertPdfName(state, convertPdfName) {
            state.convertPdfName = convertPdfName
        },
        watermarkAttach(state, watermarkAttach) {
            state.watermarkAttach = watermarkAttach
        },
        officeContractInfos(state, officeContractInfos) {
            state.officeContractInfos = officeContractInfos
        },
        officeContractMetaStr(state, officeContractMetaStr) {
            state.officeContractMetaStr = officeContractMetaStr
        }
    },
    actions: {
        ToggleSideBar: ({ commit }) => {
            commit('TOGGLE_SIDEBAR')
        },
        convertPdfName(context, convertPdfName) {
            return context.commit('convertPdfName', convertPdfName)
        },
        watermarkAttach(context, watermarkAttach) {
            return context.commit('watermarkAttach', watermarkAttach)
        },
        officeContractInfos(context, officeContractInfos) {
            return context.commit('officeContractInfos', officeContractInfos)
        },
        officeContractMetaStr(context, officeContractMetaStr) {
            return context.commit('officeContractMetaStr', officeContractMetaStr)
        }
    }
}

export default app